import React from 'react';

import { LoadingSpinner } from './loading-spinner';

/**
 * Lightweight fallback for React.lazy / Suspense route chunks.
 */
export default function PageLoader() {
  return <LoadingSpinner centered size="md" />;
}
